import { createSlice } from '@reduxjs/toolkit';

import { Notice } from '@/types/notice';
import * as asyncActions from './asyncActions';

type State = {
  notices: Notice[];
};

export const initialState: State = {
  notices: [],
};

const slice = createSlice({
  name: 'notice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(asyncActions.fetchNotices.fulfilled, (state, action) => {
      return {
        ...state,
        notices: action.payload,
      };
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
